import Api from './api';

const slug = 'v1/roleplay-scenarios';

export default {
  getScenarios(params = {}) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}`, {
        params
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  filesSummary(filesData) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/files-summary`, filesData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
}

